module.exports = __webpack_public_path__ + "img/GBP.f1ca508a.png";